import gql from 'graphql-tag';

export default gql`
fragment AdminProductListItem on AdminProduct {
    id
    ext_id
    name
    status
    price
    special_price
    special_from_date
    special_to_date
    news_from_date
    news_to_date
    categories {
        id
        name
    }
    is_mpl
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminProductListItem.ts